// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"friends-and-family_content-wrapper__WUFBz","form-box-content":"friends-and-family_form-box-content__FyyPD","required":"friends-and-family_required__JmhLS"};